import React               from 'react';
import { Route, Routes } from 'react-router-dom';
import { Locate }          from './Locate';

export const LocateRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={<Locate />}
    />
  </Routes>
);
